var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 72,
    viewBox: "0 0 36 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.49 33.66L31.02 39.93C29.76 45.345 27.27 47.535 22.59 47.085C21.84 47.025 21.03 46.89 20.16 46.68L17.64 46.08C11.385 44.595 9.45003 41.505 10.92 35.235L12.39 28.95C12.69 27.675 13.05 26.565 13.5 25.65C15.255 22.02 18.24 21.045 23.25 22.23L25.755 22.815C32.04 24.285 33.96 27.39 32.49 33.66Z",
    stroke: "#1B9CF9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.59 47.0849C21.66 47.7149 20.49 48.2399 19.065 48.7049L16.695 49.4849C10.74 51.4049 7.60502 49.7999 5.67002 43.8449L3.75002 37.9199C1.83002 31.9649 3.42002 28.8149 9.37502 26.8949L11.745 26.1149C12.36 25.9199 12.945 25.7549 13.5 25.6499C13.05 26.5649 12.69 27.6749 12.39 28.9499L10.92 35.2349C9.45002 41.5049 11.385 44.5949 17.64 46.0799L20.16 46.6799C21.03 46.8899 21.84 47.0249 22.59 47.0849Z",
    stroke: "#1B9CF9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.96 30.7949L26.235 32.6399",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.49 36.6001L21.84 37.7101",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.051baaa0a9b37adf8b2cee9ced05028e.svg";
export { ForwardRef as ReactComponent };